import React, { useRef } from 'react';
import { useState, useEffect } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import Patients from '../../modules/Patients';
import CustomButtons from '../ui-elements/Buttons/CustomButtons';
import CustomDangerButton from '../ui-elements/Buttons/CustomDangerButton';
import CustomInput from '../ui-elements/input/CustomInput';
import CustomSelect from '../ui-elements/input/CustomSelect';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useToasts } from 'react-toast-notifications';
import Autocomplete from '../../components/Apt/Autocomplete/Autocomplete';
import { useParams } from 'react-router';
import { ImCross } from 'react-icons/im';
import { DatePicker } from 'antd';
// import 'antd/dist/antd.css'; // Import Ant Design styles
import LdcApi from '../../LdcApis';
import { BsFillCloudUploadFill } from 'react-icons/bs';
import { Spin } from 'antd';
const priorityData = [
  { id: 'Routine', name: 'Routine' },
  { id: 'Urgent', name: 'Urgent' },
];

const departmentData = [
  { id: 'Dermatology', name: 'Dermatology' },
  { id: 'Surgery', name: 'Surgery' },
];
const category = [
  { id: 'Scripts', name: 'Scripts' },
  { id: 'Letters', name: 'Letters' },
  { id: 'Advice', name: 'Advice' },
  { id: 'Results', name: 'Results' },
  { id: 'Complaints', name: 'Complaints' },
];
const assignedData = [
  {
    id: '1',
    name: 'Abdul Kadir',
  },
];

const validationSchema = yup.object().shape({
  // patientName: yup.string().required('Patient Name is required'),
  jobDetails: yup.string().optional('Field is required.'),
  priority: yup.string().optional('Field is required.'),
  outComes: yup.string().optional('Field is required.'),
  department: yup.string().optional('Field To is required.'),
  category: yup.string().optional('Field is required.'),
  assignedTo: yup.string().optional('Field is required.'),
  selectDocument: yup.string().optional('Field is required.'),
});
function PatientJobForm({
  assignedData,
  patientJobDetails,
  setShowPatientForm,
  getJobDetailsPatient,
  getCaegoryListStatus,
  getRoleListStatus,
  patientLoader,
}) {
  const { id } = useParams();
  useEffect(() => {
    document.title = 'Jobs List - LDC';
  }, []);
  // let newDatient;

  // if (patientJobDetails !== undefined) {
  //   newDatient = { ...patientJobDetails, patientName: ` ${patientJobDetails?.firstName} ${patientJobDetails?.lastName}` };
  // } else {
  //   newDatient = { patientName: `` };
  // }

  // const [newDatient, setNewDatient] = useState(null);
  const [smsTemplate, setSmsTemplate] = useState(null);
  const { addToast } = useToasts();
  // const [patientFormData, setPatientFormData] = useState(newDatient);
  const [addJobDisabled, setAddJobDisabled] = useState(false);
  // const [patients, setPatients] = useState([]);
  const [isPatientList, setIsPatientList] = useState(false);
  const [patientList, setPatientList] = useState([]);

  const patientFullName = `${patientJobDetails?.firstName} ${patientJobDetails?.lastName}`;
  const [selectedPhotoFile, setSelectedPhotoFile] = useState([]);
  const [uploadPhotoError, setUploadPhotoError] = useState(false);
  const [dueDate, setDueDate] = useState(null);
  const [deuDateError, setDueDateError] = useState(false);
  const photoUploadRef = useRef(null);
  const [patientName, setPatientName] = useState('');
  const [documentTabData, setDocumentTabData] = useState([]);
  const [selectDocument, setSelectDocument] = useState('');
  const [attachmentLoader, setAttachmentLoader] = useState(false);
  const [isDocument, setIsDocument] = useState(true);
  const [isPhoto, setIsPhoto] = useState(false);
 

  useEffect(() => {
    setSmsTemplate({
      patientName: '',
      fullName: patientFullName,
    });
  }, [patientJobDetails]);

  // useEffect(() => {
  //   if (id) {
  //     id && fetchDocumentsTabData(id);
  //   }
  // }, [id]);
  useEffect(() => {
    if (id) {
      fetchDocumentsTabData(id, isDocument, isPhoto);
    }
  }, [id, isDocument, isPhoto]);

  const handleDocumentChange = () => {
    setIsDocument(true);
    setIsPhoto(false);
    setSelectDocument('')

    if (smsTemplate?.patientId) {
      const id = smsTemplate?.patientId;

      fetchDocumentsTabData(id, true, false); // directly call with new state
    }
  };

  const handlePhotoChange = () => {
    setIsPhoto(true);
    setIsDocument(false);
    setSelectDocument('')


    if (smsTemplate?.patientId) {
      const id = smsTemplate?.patientId;
      fetchDocumentsTabData(id, false, true); // directly call with new state
    }
  };

  useEffect(() => {
    if (documentTabData.length > 0) {
    }
  }, [documentTabData]);
  // useEffect(()=>{
  //   Patients.getDoctorListForAddTaskList((response)=>{
  //     if (response?.status === 'success') {
  //       setAssignedData(response.data);
  //     } else {
  //       addToast('Error Occured while Job adding Patient Job.', { appearance: 'error' });
  //     }
  //   })
  // },[])

  const formInitialSchema = {
    patientName: `${smsTemplate?.patientName}`,
    priority: '',
    jobDetails: '',
    outComes: '',
    department: '',
    category: '',
    assignedTo: '',
    selectDocument: '',
  };

  // const allPatients = () => {
  //   Patients.getAllPatients((response) => {
  //     if (response?.status === 'success') {
  //       setPatients(response?.data);
  //     }
  //   });
  // };

  // useEffect(() => {
  //   allPatients();
  // }, []);
  // useEffect(()=>{
  // },[patients])

  const onSearchPatient = (e) => {
    let val = e.target.value;
    val = val.replace(/^\s/, '');
    setSmsTemplate({
      ...smsTemplate,
      fullName: val,
    });
    setDocumentTabData([]);
    setSelectDocument('');
    let tempSuggestion = [];
    if (val.length >= 3) {
      Patients.getExistPatients(val, (response) => {
        if (response?.status === 'success') {
          if (response?.data.length > 0) {
            setIsPatientList(true);
            setPatientList(response.data);
          } else {
            setIsPatientList(false);
            setPatientList([]);
          }
        }
      });
      // tempSuggestion = patients.filter((person) => {
      //   if(person.fullName.trim().toLowerCase().includes(val.trim().toLowerCase())){
      //     return true;
      //   }else{
      //     return false;
      //   }
      // });
    } else {
      setIsPatientList(false);
      setPatientList([]);
    }
    // if(tempSuggestion.length>0){
    //   setIsPatientList(true);
    //   setPatientList([...tempSuggestion]);
    // }else{
    //   setIsPatientList(false);
    //   setPatientList([])
    // }

    // let tempSuggestion = [];
    // if (val.length >= 2) {
    //   tempSuggestion = patients.filter((person) => {
    //     return person.fullName.toLowerCase().includes(val.toLowerCase());
    //   });
    // }

    // if (val.length >= 2 && tempSuggestion.length > 0) {
    //   setIsPatientList(true);
    //   setPatientList([...tempSuggestion]);
    // } else {
    //   setIsPatientList(false);
    //   setPatientList([])
    // }
    // return setPatientList([...tempSuggestion]);
  };

  const onPatientItem = (item) => {
    setSmsTemplate({
      ...smsTemplate,
      patientId: item.id,
      patientName: item.fullName,
      fullName: item.fullName,
      // fullName: item.fullName,
      number: item.mobile,
    });
    fetchDocumentsTabData(item.id, isDocument, isPhoto);
    setPatientName(item.fullName + ` :: ${item.id}`);
    setIsPatientList(false);
    setPatientList([]);
  };

  const fetchDocumentsTabData = (id, isDocument, isPhoto) => {
    setAttachmentLoader(true);
    LdcApi({
      method: 'GET',
      url: `Patients/GetPatientAttachmentsBypatientID?patientId=${id}&isDocument=${isDocument}&isPhoto=${isPhoto}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        if (response?.status === 200) {
          setAttachmentLoader(false);
          setDocumentTabData(response?.data);
        }
      })
      .catch((error) => {
        setAttachmentLoader(false);
      });
  };

  const [validationError, setValidationError] = useState({
    patientName: false,
    jobDetails: false,
    department: false,
    priority: false,
    category: false,
    assignedTo: false,
    // selectDocument:false,
  });
  const savePatient = (values, resetForm) => {
    const formData = new FormData();
    let patientJobData = {
      patientName: smsTemplate.fullName,
      jobDetails: values.jobDetails,
      outComes: values.outComes,
      patientId:
        patientJobDetails.patientId === ''
          ? smsTemplate.patientId
          : patientJobDetails.patientId,
      assignedTo: values.department,
      priority: values.priority,
      status: 'Open',
      category: values.category,
      doctorId: values.assignedTo,
      selectDocument: values.selectDocument,
    }; //assignedTo is department and newAssignedTo is assignedTo

    let isValid = false;
    let isValidation = {
      patientName: false,
      jobDetails: false,
      department: false,
      priority: false,
      category: false,
      assignedTo: false,
      // selectDocument:false,
    };

    if (patientJobData.patientName === '') {
      isValidation.patientName = true;
      isValid = false;
    } else {
      isValid = true;
    }

    if (values.jobDetails === '') {
      isValidation.jobDetails = true;
      isValid = false;
    } else {
      isValid = true;
    }
    if (values.department === '') {
      isValidation.department = true;
      isValid = false;
    } else {
      isValid = true;
    }
    if (values.category === '') {
      isValidation.category = true;
      isValid = false;
    } else {
      isValid = true;
    }

    if (values.assignedTo === '') {
      isValidation.assignedTo = true;
      isValid = false;
    } else {
      isValid = true;
    }

    if (values.priority == '') {
      isValidation.priority = true;
      isValid = false;
    } else {
      isValid = true;
    }

    formData.append('patientName', smsTemplate.fullName);
    formData.append('jobDetails', values.jobDetails);
    formData.append('outComes', values.outComes);
    formData.append(
      'patientId',
      patientJobDetails.patientId === ''
        ? smsTemplate.patientId
        : patientJobDetails.patientId
    );
    formData.append('assignedTo', values.department);
    formData.append('priority', values.priority);
    formData.append('status', 'Open');
    formData.append('category', values.category);
    formData.append('doctorId', values.assignedTo);
    formData.append('isDocument', isDocument);
    formData.append('isPhoto', isPhoto);


    selectedPhotoFile.forEach((file) => {
      formData.append('file', file);
    });
    formData.append('PAttachmentId', selectDocument);
    if (dueDate) {
      const originalDate = new Date(dueDate['$d']);
      const formattedDate = originalDate.toISOString();
      formData.append('dueDate', formattedDate);
    } else {
      setDueDateError(true);
    }
    setValidationError(isValidation);
    if (
      dueDate &&
      !isValidation.patientName &&
      !isValidation.department &&
      !isValidation.priority &&
      !isValidation.jobDetails &&
      !isValidation.category &&
      !isValidation.assignedTo
    ) {
      setAddJobDisabled(true);
      console.log('formData', formData)
      Patients.addJobsPatients(formData, (response) => {
        if (response?.status === 'success') {
          addToast('Task added successfully.', { appearance: 'success' });
          resetForm();
          setAddJobDisabled(false);
          setUploadPhotoError(false);
          getJobDetailsPatient();
          getCaegoryListStatus();
          getRoleListStatus();
          photoUploadRef.current.value = null;
          setSelectedPhotoFile([]);
          setDueDate(null);
          setPatientName('');
          setDocumentTabData([]);
          setSelectDocument('');
          if (id === undefined) {
            setSmsTemplate({
              patientId: '',
              patientName: '',
              fullName: '',
              number: '',
            });
          }
          setShowPatientForm(false);
        } else {
          addToast('Error Occured while Job adding Patient Job.', {
            appearance: 'error',
          });
          setAddJobDisabled(false);
        }
      });
    } else {
      setAddJobDisabled(false);
    }

    if (isValid) {
      // Patients.addJobsPatients(patientJobData, (response) => {
      //   if (response?.status === 'success') {
      //     addToast('Patient Job is  added successfully.', { appearance: 'success' });
      //     resetForm();
      //     setAddJobDisabled(false);
      //     getJobDetailsPatient();
      //   } else {
      //     addToast('Error Occured while Job adding Patient Job.', { appearance: 'error' });
      //     setAddJobDisabled(false);
      //   }
      // });
    } else {
      setAddJobDisabled(false);
    }
  };
  const handleCutButtonClick = (fileName) => {
    const updatedFiles = selectedPhotoFile.filter(
      (file) => file.name !== fileName
    );
    setSelectedPhotoFile(updatedFiles);
  };
  const handleButtonClick = () => {
    // Programmatically trigger a click event on the hidden file input
    photoUploadRef.current.click();
  };
  const handlePhoto = (e) => {
    const newFiles = Array.from(e.target.files);
    if (newFiles) {
      setUploadPhotoError(false);
      setSelectedPhotoFile([...selectedPhotoFile, ...newFiles]);
    }
  };

  const handleDateChange = (date) => {
    if (date !== null) setDueDateError(false);
    if (date) {
      setDueDate(date);
    } else {
      setDueDate(null);
    }
  };
  return (
    <div>
      {smsTemplate ? (
        <Card className='p-3 mt-2'>
          <Formik
            initialValues={formInitialSchema}
            validationSchema={validationSchema}
            onSubmit={async (values, { resetForm }) => {
              await savePatient(values, resetForm);
            }}
          >
            {({
              values,
              errors,
              resetForm,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form id='patientForm' onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <label>Patient</label>
                    <Form.Group
                      className='mb-3'
                      style={{ position: 'relative' }}
                    >
                      <input
                        // style={{ borderColor: smsTemplate.fullName === '' ? 'red' : '' }}
                        autoFocus
                        disabled={patientJobDetails.firstName !== '' && true}
                        type='text'
                        name='patientName'
                        value={
                          patientJobDetails.firstName !== ''
                            ? patientJobDetails.firstName
                            : patientName
                        }
                        // onChange={handleChange}
                        className='form-control'
                        // onBlur={handleBlur}
                        // error={errors.patientName}
                        // touched={touched.patientName}
                        onChange={(e) => {
                          setPatientName(e.target.value);
                          onSearchPatient(e);
                        }}
                        // onClick={onSearchPatient}
                        required
                      />
                      {isPatientList && (
                        <div className='firstName-dropdown'>
                          <Autocomplete
                            type={patientList}
                            onFsListItem={onPatientItem}
                          />
                        </div>
                      )}
                      {patientLoader && (
                        <p
                          style={{
                            position: 'absolute',
                            top: '6px',
                            right: '20px',
                            marginBottom: '0px',
                          }}
                        >
                          <Spin />
                        </p>
                      )}
                      {validationError.patientName && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <label>Priority</label>
                    <Form.Group className='mb-3'>
                      <CustomSelect
                        defaultValue='Select'
                        value={values.priority}
                        name='priority'
                        onChange={handleChange}
                        selectData={priorityData}
                        onBlur={handleBlur}
                        error={errors.priority}
                        touched={touched.priority}
                        // required
                      />
                      {touched.priority && errors.priority && (
                        <small className='text-danger error_field'>
                          {errors.priority}
                        </small>
                      )}
                      {validationError.priority && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <label>Task Details</label>
                    <Form.Group className='mb-3'>
                      <textarea
                        cols='60'
                        rows='3'
                        style={{ borderColor: errors.jobDetails ? 'red' : '' }}
                        name='jobDetails'
                        className='form-control'
                        placeholder='Task Details'
                        value={values.jobDetails}
                        onBlur={handleBlur}
                        error={errors.jobDetails}
                        touched={touched.jobDetails}
                        onChange={handleChange}
                        ////style={{ width: '100%', marginTop: '-10px' }}
                        // required
                      />
                      {validationError.jobDetails && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <label>Outcome</label>
                    <Form.Group className='mb-3'>
                      <textarea
                        cols='60'
                        rows='3'
                        name='outComes'
                        className='form-control'
                        placeholder='Outcome'
                        value={values.outComes}
                        onBlur={handleBlur}
                        error={errors.outComes}
                        touched={touched.outComes}
                        onChange={handleChange}
                        //style={{ width: '100%', marginTop: '-10px' }}
                      />
                      {/* {touched.outComes && errors.outComes && <small className="text-danger error_field">{errors.outComes}</small>} */}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    {/*Previous Assigned to task*/}
                    <label>Department</label>
                    <Form.Group className='mb-3'>
                      <CustomSelect
                        defaultValue='Select'
                        value={values.department}
                        name='department'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ borderColor: errors.department ? 'red' : '' }}
                        error={errors.department}
                        touched={touched.department}
                        // required
                        selectData={departmentData}
                      />
                      {validationError.department && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <label>Category</label>
                    <Form.Group className='mb-3'>
                      <CustomSelect
                        defaultValue='Select'
                        value={values.category}
                        name='category'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ borderColor: errors.category ? 'red' : '' }}
                        error={errors.category}
                        touched={touched.category}
                        // required
                        selectData={category}
                      />
                      {validationError.category && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <label>Assigned To</label>
                    <Form.Group className='mb-3'>
                      <CustomSelect
                        defaultValue='Select'
                        value={values.assignedTo}
                        name='assignedTo'
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        style={{ borderColor: errors.category ? 'red' : '' }}
                        error={errors.assignedTo}
                        touched={touched.assignedTo}
                        // required
                        selectData={assignedData}
                      />
                      {validationError.assignedTo && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <label>Due Date</label>
                    <Form.Group className='mb-3'>
                      <DatePicker
                        value={dueDate}
                        onChange={handleDateChange}
                        format='DD/MM/YYYY'
                      />
                      {deuDateError && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <label htmlFor='uploadPhoto'>Upload</label>
                    <label style={{ marginLeft: '15px' }}>
                      <BsFillCloudUploadFill
                        size={18}
                        onClick={handleButtonClick}
                        style={{ cursor: 'pointer' }}
                      />
                    </label>
                    <Form.Group className='mb-3' style={{ width: '100%' }}>
                      <div
                        className='form-control'
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          gap: '20px',
                          height: '80px',
                          overflowY: 'auto',
                        }}
                      >
                        <div
                          style={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '10px',
                          }}
                        >
                          {selectedPhotoFile.map((file) => {
                            return (
                              <p
                                key={file.name}
                                style={{
                                  display: 'flex',
                                  gap: '10px',
                                  alignItems: 'center',
                                  border: '1px solid gray',
                                  background: 'aliceblue',
                                  padding: '3px 10px',
                                  borderRadius: '3px',
                                  height: 'max-content',
                                }}
                              >
                                {file.name}
                                {
                                  <ImCross
                                    size={12}
                                    style={{ color: 'red', cursor: 'pointer' }}
                                    onClick={() =>
                                      handleCutButtonClick(file.name)
                                    }
                                  />
                                }
                              </p>
                            );
                          })}
                        </div>
                        <input
                          type='file'
                          name='uploadPhoto'
                          className='form-control'
                          onChange={handlePhoto}
                          ref={photoUploadRef}
                          multiple
                          contentEditable
                          style={{ display: 'none' }}
                        />
                      </div>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group
                      className='mb-0'
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      <Form.Label
                        style={{ marginRight: '15px', minWidth: '120px' }}
                      >
                        Select Document : 
                      </Form.Label>

                     <label style={{ marginRight: '15px', display: 'flex', alignItems: 'center' }}>
                        <input
                          type='checkbox'
                          checked={isDocument}
                          onChange={handleDocumentChange}
                            style={{ marginRight: '5px' }}
                        />
                        Document
                      </label>

                     <label style={{ marginRight: '15px', display: 'flex', alignItems: 'center' }}>
                        <input
                          type='checkbox'
                          checked={isPhoto}
                          onChange={handlePhotoChange}
                            style={{ marginRight: '5px' }}
                        />
                        Photo
                      </label>
                    </Form.Group>

                    <Form.Group
                      className='mb-3'
                      style={{ position: 'relative' }}
                    >
                      <CustomSelect
                        defaultValue={isDocument ? 'Select Document' : 'Select Photo'}
                        value={selectDocument}
                        name='selectDocument'
                        onChange={(e) => {
                          // handleChange(e)
                          setSelectDocument(e.target.value);
                        }}
                        onBlur={handleBlur}
                        // style={{ borderColor: errors.category ? 'red' : '' }}
                        // error={errors.selectDocument}
                        touched={touched.selectDocument}
                        // required
                        selectData={documentTabData}
                      />
                      {attachmentLoader && (
                        <p
                          style={{
                            position: 'absolute',
                            top: '8px',
                            right: '30px',
                            marginBottom: '0px',
                          }}
                        >
                          <Spin />
                        </p>
                      )}
                      {/* {validationError.selectDocument && <small className="text-danger error_field">Field is required.</small>} */}
                    </Form.Group>
                  </Col>
                </Row>
                <div className='my-4 mb-3 p-2 d-flex'>
                  <CustomButtons
                    buttonDisabled={addJobDisabled}
                    type='submit'
                    variant='primary'
                    name={addJobDisabled ? 'Loading...' : 'Save'}
                  />
                  <CustomDangerButton
                    cancelOnClick={() => setShowPatientForm(false)}
                    variant='danger'
                    name='Cancel'
                  />
                </div>
              </Form>
            )}
          </Formik>
        </Card>
      ) : (
        <p>loading...</p>
      )}
    </div>
  );
}

export default PatientJobForm;
